import api from '../lib/axios';
import type { ApiResponse, ProjectRoundSummary, ProjectRoundDetail, IssueDashboard } from '@maios/shared';

/** GET /projects/:projectId/test-results/rounds → 회차 목록 */
export async function fetchRounds(projectId: string) {
  const res = await api.get<ApiResponse<ProjectRoundSummary[]>>(
    `/projects/${projectId}/test-results/rounds`,
  );
  return res.data.data!;
}

/** GET /projects/:projectId/test-results/rounds/:roundNumber → 회차 상세 */
export async function fetchRoundDetail(projectId: string, roundNumber: number) {
  const res = await api.get<ApiResponse<ProjectRoundDetail>>(
    `/projects/${projectId}/test-results/rounds/${roundNumber}`,
  );
  return res.data.data!;
}

/** GET /projects/:projectId/issues/dashboard → 이슈 대시보드 */
export async function fetchIssueDashboard(projectId: string) {
  const res = await api.get<ApiResponse<IssueDashboard>>(
    `/projects/${projectId}/issues/dashboard`,
  );
  return res.data.data!;
}
